import Swal from 'sweetalert2';
export default (editor, opts = {}) => {
    const PNS = editor.Panels;
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const COMPONENT_TYPE = 'C-MODAL-LOCK-RECORD';

    let model = MODEL.extend({
        defaults: {
            ...MODEL.prototype.defaults,
            name: "Modal Lock Record",
            tagName: 'div',
            attributes: {
                id: COMPONENT_TYPE,
                "data-slg-type": COMPONENT_TYPE,
                "data-slg-match-response": null,

                "data-bs-backdrop": false,
                "data-bs-keyboard": false,
                "aria-hidden": "true",
                tabindex: '-1'
            },
            classes: ['modal', 'fade', 'show'],
            style: {
                display: 'block',
            },
            droppable: false,
            components: [
                {
                    name: "Modal Dialog",
                    tagName: 'div',
                    droppable: false,
                    draggable: false,
                    classes: ['modal-dialog'],
                    components: [
                        {
                            name: "Modal Content",
                            tagName: 'div',
                            droppable: false,
                            draggable: false,
                            classes: ['modal-content'],
                            components: [
                                /* Modal header */
                                {
                                    name: "Modal Header",
                                    tagName: 'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes: ['modal-header'],
                                    components: [
                                        /* Modal title */
                                        {
                                            name: "Modal Title",
                                            type: 'header',
                                            tagName: "h5",
                                            droppable: false,
                                            draggable: false,
                                            classes: ['modal-title'],
                                            components: [
                                                {
                                                    type: "textnode",
                                                    content: 'Title'
                                                }
                                            ]

                                        },
                                        /* Modal close */
                                        {
                                            name: "Close",
                                            tagName: 'button',
                                            droppable: false,
                                            draggable: false,
                                            attributes: {
                                                'data-slg-control-dismiss': 'modal',
                                                'aria-label': 'Close',
                                                'type': 'button',
                                                'data-dismiss': "modal"
                                            },
                                            classes: ['close', 'btn-close'],
                                            components:/*html*/`
                                                <span aria-hidden="true">&times;</span>
                                            `
                                        }
                                    ]
                                },
                                {
                                    name: "Modal Body",
                                    tagName: 'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes: ['modal-body'],
                                    components: [
                                        {
                                            droppable: false,
                                            draggable: false,
                                            type: 'paragraph',
                                            content: 'Insert your message here'
                                        }
                                    ]
                                },
                                {
                                    name: "Modal Footer",
                                    tagName: 'div',
                                    // droppable:false,
                                    draggable: false,
                                    classes: ['modal-footer'],
                                    components: [
                                        {
                                            type: "button",
                                            tagName: 'button',
                                            editable: true,
                                            content: 'Close',
                                            classes: ['btn', 'btn-secondary'],
                                            attributes: {
                                                'type': 'button',
                                                'data-dismiss': "modal",
                                            }
                                        },
                                    ]
                                }
                            ]

                        }
                    ]

                }
            ],
            traits: [
                {
                    type: 'text',
                    label: 'Match Response',
                    name: 'data-slg-match-response',
                }
            ]
        }

    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute('data-slg-type') == COMPONENT_TYPE)
                return { type: COMPONENT_TYPE }
        }
    });

    let view = VIEW.extend({
        onRender() {
            let component = this.model;
            this.initModalInEditor();
        },
        initModalInEditor() {

            let canvasDocument = editor.Canvas.getDocument();
            let el = this.el;
            let closeElement = el.querySelectorAll(`.btn-close`);

        },
    });

    DOMC.addType(COMPONENT_TYPE, {
        model,
        view
    });

    BM.add(COMPONENT_TYPE, {
        label: COMPONENT_TYPE,
        content: {
            type: COMPONENT_TYPE,
        },
        // media:sponsors,
        category: "LEADGREASE INTEGRATION"
    });

    // Comando para ocultar y mostrar el model
    COMMANDS.add(`${COMPONENT_TYPE}:toggle`, {
        run(editor, sender) {
            let eComponents = editor.getWrapper();
            let cModal = eComponents.findType(COMPONENT_TYPE);
            cModal = (cModal.length > 0) ? cModal[0] : null;
            if(cModal){
                let find = cModal.getClasses().find(cls => cls == 'show');
                if(find){
                    cModal.removeClass('show');
                    cModal.setStyle({'display': 'none'});
                }else{
                    cModal.addClass('show');
                    cModal.setStyle({'display': 'block'});
                }
            }
        }
    });

    // Solo se mostrara el botton toggle modal cuando exista un modal

    let loadButtonToggleModalInPanel = () => {
        let eComponents = editor.getWrapper();
        let cModal = eComponents.findType(COMPONENT_TYPE);
        cModal = (cModal.length > 0) ? cModal[0] : null;
        let buttonPanel = PNS.getButton("options", COMPONENT_TYPE);
        if(cModal && !buttonPanel){
            // Boton que ejecuta el comando de toggle modal en el editor
            PNS.addButton("options", {
                id: COMPONENT_TYPE,
                className: 'fa fa-lock',
                command: `${COMPONENT_TYPE}:toggle`,
                attributes: {
                    title: 'Modal Lock Record'
                },
                active: false,
            });
        }
    }
    loadButtonToggleModalInPanel();
    editor.on('load', loadButtonToggleModalInPanel);
    editor.on('update', loadButtonToggleModalInPanel);


    editor.on('block:drag:stop', async (model) => {
        if(model && model.is(COMPONENT_TYPE)){
            let wrapper = editor.getWrapper();
            let find = wrapper.findType(COMPONENT_TYPE);

            if(find.length > 1){

                let result = await Swal.fire({
                    title: 'Modal already created!',
                    icon: 'warning',
                    text: `There can only be one modal ${COMPONENT_TYPE} in the page. Do you want to delete the other one?`,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, create it!'
                })
                if(result.isConfirmed){
                    find[0].remove();
                }else{
                    find[1].remove();
                }

                return;
            }
        }
            
    });

};
